// Single source of truth for the NotesAI <-> vosk-service integration.
//
// The Vosk browser STT bundle and model archives are served by the
// standalone notesai-vosk-service repo as a static CDN. The SPA fetches
// the manifest, then loads vosk.js and the resolved model URL.
//
// The origin is read from src/components/env.js so it can be edited without
// restarting the CRA dev server (env-file edits don't HMR).

import { VOSK_SERVICE_ORIGIN as ENV_VOSK_SERVICE_ORIGIN } from "../../components/env.js";

export const VOSK_SERVICE_ORIGIN = String(ENV_VOSK_SERVICE_ORIGIN || "").replace(/\/+$/, "");
export const VOSK_MANIFEST_URL = `${VOSK_SERVICE_ORIGIN}/api/v1/manifest.json`;
export const VOSK_JS_URL = `${VOSK_SERVICE_ORIGIN}/api/v1/vosk.js`;

export const voskModelUrl = (entry) => {
  if (!entry || !entry.url) return "";
  const u = entry.url.startsWith("/") ? entry.url : "/" + entry.url;
  return `${VOSK_SERVICE_ORIGIN}${u}`;
};

// Cache the resolved manifest at module scope so multiple call sites share
// the same fetch. Refreshed every 5 minutes (matches manifest Cache-Control).
let __manifestCache = null;
let __manifestInflight = null;
let __manifestCachedAt = 0;
const MANIFEST_TTL_MS = 5 * 60 * 1000;

export async function fetchVoskManifest({ force = false } = {}) {
  const now = Date.now();
  if (!force && __manifestCache && now - __manifestCachedAt < MANIFEST_TTL_MS) {
    return __manifestCache;
  }
  if (__manifestInflight) return __manifestInflight;
  __manifestInflight = fetch(VOSK_MANIFEST_URL, { cache: "force-cache" })
    .then((r) => {
      if (!r.ok) throw new Error(`Vosk manifest HTTP ${r.status}`);
      return r.json();
    })
    .then((m) => {
      __manifestCache = m;
      __manifestCachedAt = Date.now();
      __manifestInflight = null;
      return m;
    })
    .catch((err) => {
      __manifestInflight = null;
      throw err;
    });
  return __manifestInflight;
}

export async function resolveVoskModel(modelId) {
  const manifest = await fetchVoskManifest();
  const entry =
    (Array.isArray(manifest?.models) &&
      manifest.models.find((m) => m && m.id === modelId)) ||
    (Array.isArray(manifest?.models) && manifest.models[0]);
  if (!entry) throw new Error(`No Vosk model found in manifest`);
  return { entry, url: voskModelUrl(entry) };
}